import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tooltip, Popover } from 'antd';
import TEXT from '../Text';
import moment from 'moment';
import cn from 'classnames';
import { Dropdown, Menu } from 'antd';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import emptyCpayImage from '../../../img/cpay-svg/empty.svg';
import emptyNFGImage from '../../../img/nfgpay-svg/empty-nfg.svg';
import emptyFinvaroImage from '../../../img/finvaro/empty-finvaro.svg';
import emptyClarniumImage from '../../../img/clarnium/empty-clarnium.svg';
import emptyInexImage from '../../../img/inex/empty-inex.svg';
import emptyInstaImage from '../../../img/instaXchange/empty-insta.svg';
import emptyCoineraImage from '../../../img/coinera/empty-coinera.svg';
import { ReactComponent as SortingArrow } from '../../../img/adminPanel/sorting-arrow.svg';
import { ReactComponent as TransactionArrow } from '../../../img/adminPanel/arrow.svg';
import { ReactComponent as SelectArrowIcon } from '../../../img/swap-svg/swap-select-arrow.svg';

import { identity } from '../../../utils/getIdentity';

import './style.scss';
import AddUserModal from "../RoleSettings/AddUserModal";

const emptyImage = {
  cpay: emptyCpayImage,
  nfg: emptyNFGImage,
  finvaro: emptyFinvaroImage,
  clarnium: emptyClarniumImage,
  inex: emptyInexImage,
  insta: emptyInstaImage,
  coinera: emptyCoineraImage
};

const UsersList = ({
  usersList,
  setSelectedUserId,
  usersFetching,
  handleClick,
  setSortRole,
  sortRole,
  handleClickSort,
  setSortBalance,
  selectedOrder,
  setSelectedOrder,
  handleClickProfile,
  setSortProfile,
  sortProfile,
  permissions,
  rolesList,
  updateAdminUser,
  getAdminUsers,
  transactionsFilter,
  setTransactionsFilter,
  handleClickAgent,
  selectedAgent
}) => {
  const [sortingIsClicked, setSortingIsClicked] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showPopover, setShowPopover] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [sortingRoleIsClicked, setSortingRoleIsClicked] = useState(false);
  const [sortingProfileIsClicked, setSortingProfileIsClicked] = useState(false);
  const [sortingAgentIsClicked, setSortingAgentIsClicked] = useState(false);
  const [isOpenRoleModal, setIsOpenRoleModal] = useState(false);
  const [userId, setUserId] = useState('');

  const language = localStorage.getItem('cpayAppLang');

  const { t } = useTranslation();

  const timer = useRef(null);

  const handleOpen = (id) => {
    setUserId(id);
    setIsOpenRoleModal(true)
  }

  const handleTransactionsFilter = () => {
    if (transactionsFilter === 'DESC') {
      setTransactionsFilter('ASC');
    } else if (transactionsFilter === 'ASC') {
      setTransactionsFilter(undefined);
    } else {
      setTransactionsFilter('DESC');
    }
  }

  const currentRole = localStorage.getItem('role');

  useEffect(() => {
    handleClickSort(currentRole);
    setSortRole(currentRole);
  }, [currentRole]);

  const handleChange = e => {
    if (selectedOrder) {
      return;
    }
    setSortingIsClicked(prev => !prev);
  };

  const handleChangeSort = e => {
    if (sortRole) {
      return;
    }
    setSortingRoleIsClicked(prev => !prev);
  };

  const handleChangeProfile = e => {
    if (sortProfile || (!sortProfile && sortProfile !== undefined)) {
      return;
    }
    setSortingProfileIsClicked(prev => !prev);
  };

  const handleChangeAgent = e => {
    if (selectedAgent || (!selectedAgent && selectedAgent !== undefined)) {
      return;
    }
    setSortingAgentIsClicked(prev => !prev);
  };

  useEffect(() => {
    return sortRole ? setSortingRoleIsClicked(true) : setSortingRoleIsClicked(false);
  }, [sortRole]);

  useEffect(() => {
    return selectedOrder ? setSortingIsClicked(true) : setSortingIsClicked(false);
  }, [selectedOrder]);

  useEffect(() => {
    return sortProfile !== undefined ? setSortingProfileIsClicked(true) : setSortingProfileIsClicked(false);
  }, [sortProfile]);

  useEffect(() => {
    return selectedAgent !== undefined ? setSortingAgentIsClicked(true) : setSortingAgentIsClicked(false);
  }, [selectedAgent]);

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
      timer.current = null;
    };
  }, []);

  useEffect(() => {
    showPopover && setShowTooltip(false);
  }, [showPopover]);

  const updateUser = (userId, roleId) => {
    updateAdminUser(userId, { accessRole: roleId });

    setTimeout(() => {
      getAdminUsers();
    }, 500)
  }

  const copyHandler = (email, phone, metamaskAddress, e) => {
    const credential = email || phone || metamaskAddress;
    e.stopPropagation();
    navigator.clipboard.writeText(credential);
    setShowPopover(true);
    timer.current = setTimeout(() => setShowPopover(false), 500);
  };

  const mouseEnterHandler = userId => {
    setCurrentUser(userId);
    setShowTooltip(true);
    setShowPopover(false);
  };

  return (
    <div className={`admin-users__list`}>
      <div className={`admin-users__list-row admin-users__list-row_legend admin-users__list-row_legend-${identity}`}>
        <div className={`admin-users__list-item admin-users__filter`}>
          <TEXT.grayBold>{t("admin.profile")}</TEXT.grayBold>
          <div className={cn("sorting-icon-filter", { "sorting-icon-filter-clicked": sortingProfileIsClicked })}>
            <Dropdown
              placement="bottomRight"
              trigger={["click", "hover"]}
              onVisibleChange={handleChangeProfile}
              overlay={
                <div className={`admin-users__filter-list admin-users__filter-list-${identity}`}>
                  <div
                    className={cn(`admin-users__filter-list-item admin-users__filter-list-item-${identity}`, {
                      [`admin-users__filter-list-item-active admin-users__filter-list-item-active-${identity}`]: sortProfile
                    })}
                    onClick={() => {
                      handleClickProfile(sortProfile === true ? undefined : true);
                      setSortProfile(sortProfile === true ? undefined : true);
                    }}
                  >
                    {t("admin.active")}
                  </div>
                  <div
                    className={cn(`admin-users__filter-list-item admin-users__filter-list-item-${identity}`, {
                      [`admin-users__filter-list-item-active admin-users__filter-list-item-active-${identity}`]: sortProfile === false
                    })}
                    onClick={() => {
                      handleClickProfile(sortProfile === false ? undefined : false);
                      setSortProfile(sortProfile === false ? undefined : false);
                    }}
                  >
                    {t("admin.non_active")}
                  </div>
                </div>
              }
            >
              <div className="sorting-icon-filter__icon-wrapper">
                <SelectArrowIcon />
              </div>
            </Dropdown>
          </div>
        </div>
        {/*{identity === 'inex' && (
          <div className={`admin-users__list-item admin-users__list-item--${identity} admin-users__filter`}>
            <TEXT.grayBold>Agent</TEXT.grayBold>
            <div className={cn("sorting-icon-filter", { "sorting-icon-filter-clicked": sortingAgentIsClicked })}>
              <Dropdown
                placement="bottomRight"
                trigger={["click", "hover"]}
                onVisibleChange={handleChangeAgent}
                overlay={
                  <div className={`admin-users__filter-list admin-users__filter-list-${identity}`}>
                    <div
                      className={cn(`admin-users__filter-list-item admin-users__filter-list-item-${identity}`, {
                        [`admin-users__filter-list-item-active admin-users__filter-list-item-active-${identity}`]: selectedAgent === false
                      })}
                      onClick={() => {
                        handleClickAgent(false);
                      }}
                    >
                      All
                    </div>
                    <div
                      className={cn(`admin-users__filter-list-item admin-users__filter-list-item-${identity}`, {
                        [`admin-users__filter-list-item-active admin-users__filter-list-item-active-${identity}`]: selectedAgent
                      })}
                      onClick={() => {
                        handleClickAgent(true);
                      }}
                    >
                      Panther
                    </div>
                  </div>
                }
              >
                <div className="sorting-icon-filter__icon-wrapper">
                  <SelectArrowIcon />
                </div>
              </Dropdown>
            </div>
          </div>
        )}*/}
        <div className={`admin-users__list-item`}>
          <TEXT.grayBold>{t("admin.email_phone")}</TEXT.grayBold>
        </div>
        <div className={`admin-users__list-item`}>
          <TEXT.grayBold>{t("admin.date_registration")}</TEXT.grayBold>
        </div>
        <div className={`admin-users__list-item`}>
          <TEXT.grayBold>{t("admin.last_login")}</TEXT.grayBold>
        </div>
        <div className={`admin-users__list-item admin-users__filter`}>
          <TEXT.grayBold>{t("admin.role")}</TEXT.grayBold>
          <div className={cn("sorting-icon-filter", { "sorting-icon-filter-clicked": sortingRoleIsClicked })}>
            <Dropdown
              placement="bottomRight"
              trigger={["click", "hover"]}
              onVisibleChange={handleChangeSort}
              overlay={
                <div className={`admin-users__filter-list admin-users__filter-list-${identity}`}>
                  <div
                    className={cn(`admin-users__filter-list-item admin-users__filter-list-item-${identity}`, {
                      [`admin-users__filter-list-item-active admin-users__filter-list-item-active-${identity}`]: sortRole === "corporate"
                    })}
                    onClick={() => {
                      handleClickSort(sortRole === "corporate" ? undefined : "corporate");
                      setSortRole(sortRole === "corporate" ? undefined : "corporate");
                    }}
                  >
                    {t("admin.user")}
                  </div>
                  {rolesList?.map((item) => (
                    <div
                      className={cn(`admin-users__filter-list-item admin-users__filter-list-item-${identity}`, {
                        [`admin-users__filter-list-item-active admin-users__filter-list-item-active-${identity}`]: sortRole === item?.name
                      })}
                      onClick={() => {
                        handleClickSort(sortRole === item?.name ? undefined : item?.name);
                        setSortRole(sortRole === item?.name ? undefined : item?.name);
                      }}
                    >
                      {item?.name.charAt(0).toUpperCase() + item?.name.slice(1)}
                    </div>
                  ))}
                </div>
              }
            >
              <div className="sorting-icon-filter__icon-wrapper">
                <SelectArrowIcon />
              </div>
            </Dropdown>
          </div>
        </div>
        {/* <div className={`admin-users__list-item admin-users__list-item--sort`} onClick={handleTransactionsFilter}>
          <TEXT.grayBold>{t("admin.transactions")} {transactionsFilter && <TransactionArrow
            className={`${transactionsFilter === "ASC" && "admin-users__list-item--arrow"}`} />}</TEXT.grayBold>
        </div> */}
        <div className={`admin-users__list-item admin-users__balance`}>
          <TEXT.grayBold>
            {t("admin.mainnet")} <br /> {t("admin.balance")}
          </TEXT.grayBold>
          <div className={cn("sorting-icon", { "sorting-icon-clicked": sortingIsClicked })}>
            <Dropdown
              placement="bottomRight"
              trigger={["click", "hover"]}
              onVisibleChange={handleChange}
              overlay={
                <Menu>
                  <Menu.Item
                    className={selectedOrder === "DESC" ? `admin-users__balance-item-active admin-users__balance-item-active-${identity}` : null}
                    onClick={() => {
                      handleClick("DESC", selectedOrder === "DESC" ? undefined : "balanceUSD");
                      setSelectedOrder(selectedOrder === "DESC" ? undefined : "DESC");
                      setSortBalance(selectedOrder === "DESC" ? undefined : "balanceUSD");
                    }}
                  >
                    {t("admin.highest_lowest")}
                  </Menu.Item>
                  <Menu.Item
                    className={selectedOrder === "ASC" ? `admin-users__balance-item-active admin-users__balance-item-active-${identity}` : null}
                    onClick={() => {
                      handleClick(
                        selectedOrder === "ASC" ? "DESC" : "ASC",
                        selectedOrder === "ASC" ? undefined : "balanceUSD"
                      );
                      setSelectedOrder(selectedOrder === "ASC" ? undefined : "ASC");
                      setSortBalance(selectedOrder === "ASC" ? undefined : "balanceUSD");
                    }}
                  >
                    {t("admin.lowest_highest")}
                  </Menu.Item>
                </Menu>
              }
            >
              <SortingArrow className="icon" />
            </Dropdown>
          </div>
        </div>
      </div>

      {!usersFetching ? (
        <>
          {usersList.length ? (
            usersList.map(user => (
              <div className={`admin-users__list-row admin-users__list-row-${identity}`} key={user.id}>
                <div className={`admin-users__list-item admin-users__user-name`}>
                  <div
                    className={`admin-users__color-status ${
                      user.isActive ? "admin-users__color-status_active" : "admin-users__color-status_inactive"
                    }`}
                  ></div>
                  <TEXT.darkBold>
                    {user.name} {user.surname}
                  </TEXT.darkBold>
                </div>
                {/*{identity === 'inex' && (
                  <div className={`admin-users__list-item admin-users__list-item--${identity}`}>
                    <TEXT.darkBold>{user?.agent || "web"}</TEXT.darkBold>
                  </div>
                )}*/}
                <Tooltip title={t("clickToCopy")} visible={user.id === currentUser && showTooltip} placement="top">
                <Popover
                    title=""
                    content={t("copied")}
                    trigger="click"
                    visible={user.id === currentUser && showPopover}
                    hidden={true}
                  >
                    <div
                      className={`admin-users__list-item admin-users__email`}
                      onClick={e => copyHandler(user.email, user.phone, user.metamask?.address, e)}
                      onMouseEnter={() => mouseEnterHandler(user.id)}
                      onMouseLeave={() => setCurrentUser(null)}
                    >
                      <TEXT.darkBold>{user.email || user.phone || user?.metamask?.address}</TEXT.darkBold>
                      {user.email && (
                        <TEXT.grayBoldSmall>{user.emailConfirmed ? t("admin.confirmed") : t("admin.not_confirmed")}</TEXT.grayBoldSmall>
                      )}
                    </div>
                  </Popover>
                </Tooltip>

                <div className={`admin-users__list-item`}>
                  <TEXT.darkBold>{moment(user.createdAt).locale(language === "es" ? "es" : "en-gb").format("MMMM D, YYYY, HH:mm")}</TEXT.darkBold>
                </div>
                <div className={`admin-users__list-item`}>
                  <TEXT.darkBold>
                    {user.lastLogin ? moment(user.lastLogin).locale(language === "es" ? "es" : "en-gb").format("MMMM D, YYYY, HH:mm") : "-"}
                  </TEXT.darkBold>
                </div>
                <div className={`admin-users__list-item`}>
                  <TEXT.darkBold>{user?.accessRole?.name || ((user?.role === "corporate" || user?.role === "individual") ? t("admin.user") : user?.role) || "-"}</TEXT.darkBold>
                </div>
                {/* <div className={`admin-users__list-item`}>
                  <div className="admin-users__list-item-transactions">
                    <div>{t("admin.total")}: {user?.transactions?.total}</div>
                    <div>{t("admin.recurring")}: {user?.transactions?.recurringPayment}</div>
                    <div>{t("admin.replenishment")}: {user?.transactions?.replenishment}</div>
                    <div>{t("admin.withdrawal")}: {user?.transactions?.withdrawal}</div>
                    <div>{t("admin.swap")}: {user?.transactions?.swap}</div>
                  </div>
                </div> */}
                <div className={`admin-users__list-item`}>
                  <TEXT.darkBold>{user.balanceUSD.toFixed(2) || 0}$</TEXT.darkBold>
                </div>
                <div className={`admin-users__list-item admin-users__list-item-${identity}`}>
                  <Dropdown
                    placement="bottomRight"
                    overlay={
                      <Menu className={`admin-menu-${identity}`}>
                        <Menu.Item className={`admin-item-${identity}`}>
                          <div onClick={() => setSelectedUserId(user.id)}>{t("admin.profile")}</div>
                        </Menu.Item>
                        {permissions && permissions?.length > 0 && permissions[1]?.edit && (
                          <Menu.Item className={`admin-item-${identity}`}>
                            <Link className={`admin-link-${identity}`}
                                  to={`/admin/user-edit/${user.id}`}>{t("admin.edit")}</Link>
                          </Menu.Item>
                        )}
                        {permissions?.length && permissions[2]?.view && (
                          <Menu.Item className={`admin-item-${identity}`}>
                            <Link className={`admin-link-${identity}`}
                                  to={`/admin/user-fees/${user.id}`}>{t("admin.fees")}</Link>
                          </Menu.Item>
                        )}
                        {permissions?.length && permissions[3]?.view && (
                          <Menu.Item className={`admin-item-${identity}`}>
                            <Link className={`admin-link-${identity}`}
                                  to={`/admin/user-accounts/${user.id}`}>{t("admin.accounts")}</Link>
                          </Menu.Item>
                        )}
                        {permissions?.length && permissions[5]?.view && (
                          <Menu.Item className={`admin-item-${identity}`}>
                            <Link className={`admin-link-${identity}`}
                                  to={`/admin/user-transactions/${user.id}`}>{t("admin.transactions")}</Link>
                          </Menu.Item>
                        )}
                        <Menu.Item className={`admin-item-${identity}`}>
                          <Link className={`admin-link-${identity}`}
                                to={`/admin/login-history/${user.id}`}>{t("admin.login_history")}</Link>
                        </Menu.Item>
                        {permissions?.length && permissions[2]?.view && (
                          <Menu.Item className={`admin-item-${identity}`} onClick={() => handleOpen(user?.id)}>
                            {t("admin.add_role")}
                          </Menu.Item>
                        )}
                      </Menu>
                    }
                  >
                    <span className="admin-users__actions">...</span>
                  </Dropdown>
                </div>


              </div>
            ))
          ) : (
            <div className="admin-users__empty">
              <span className="admin-users__empty-title">{t("admin.users_will_show")}</span>
              <img src={emptyImage[identity]} className="admin-users__empty-image" alt="empty" />
            </div>
          )}
        </>
      ) : (
        <div className="admin-users__loader">
          <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
        </div>
      )}

      <AddUserModal
        visible={isOpenRoleModal}
        close={() => setIsOpenRoleModal(false)}
        rolesList={rolesList}
        usersId={userId}
        updateAdminUser={updateUser}
        getAdminUsers={getAdminUsers}
        usersList={usersList}
      />
    </div>
  );
};

export default UsersList;
